document.addEventListener('DOMContentLoaded', function() {

    const gridBtn = document.getElementById('gridView');
    const listBtn = document.getElementById('listView');
    const container = document.getElementById('unitsContainer');

    function applyView(view) {

        const items = document.querySelectorAll('.grid-cell');

        if (view === 'list') {

            container.classList.remove('grid-view');
            container.classList.add('list-view');

            listBtn.classList.add('active');
            gridBtn.classList.remove('active');

            items.forEach(item => {
                item.classList.remove('cell-lg-4');
                item.classList.add('cell-lg-6');
            });

        } else {

            container.classList.remove('list-view');
            container.classList.add('grid-view');

            gridBtn.classList.add('active');
            listBtn.classList.remove('active');

            items.forEach(item => {
                item.classList.remove('cell-lg-6');
                item.classList.add('cell-lg-4');
            });

        }
    }

    /* ✅ LOAD SAVED VIEW */
    const savedView = localStorage.getItem('unitsView') || 'grid';
    applyView(savedView);

    /* CLICK EVENTS */

    gridBtn.addEventListener('click', function() {
        localStorage.setItem('unitsView', 'grid');
        applyView('grid');
    });

    listBtn.addEventListener('click', function() {
        localStorage.setItem('unitsView', 'list');
        applyView('list');
    });

});